import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { login } from '../services/api'

export default function Login() {
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')
  const [load, setLoad] = useState(false)
  const navigate = useNavigate()

  async function entrar(e) {
    e.preventDefault()
    setErro('')
    setLoad(true)
    try {
      const res = await login(email, senha)
      localStorage.setItem('pg_token', res.data.token)
      localStorage.setItem('pg_usuario', JSON.stringify(res.data.usuario))
      navigate('/dashboard')
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao fazer login')
    } finally {
      setLoad(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0d3d6b 0%, #185FA5 50%, #1e7bc4 100%)',
      fontFamily: "'Inter', system-ui, sans-serif",
      padding: '16px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Círculos decorativos de fundo */}
      <div style={{
        position: 'absolute', top: '-80px', right: '-80px',
        width: '320px', height: '320px', borderRadius: '50%',
        background: 'rgba(255,255,255,0.05)', pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', bottom: '-60px', left: '-60px',
        width: '240px', height: '240px', borderRadius: '50%',
        background: 'rgba(255,255,255,0.04)', pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', top: '40%', left: '-40px',
        width: '160px', height: '160px', borderRadius: '50%',
        background: 'rgba(255,255,255,0.03)', pointerEvents: 'none',
      }} />

      <div style={{ width: '100%', maxWidth: 400, position: 'relative', zIndex: 1 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 56, height: 56, borderRadius: 16,
            background: 'rgba(255,255,255,0.15)',
            backdropFilter: 'blur(8px)',
            marginBottom: 16,
            border: '1px solid rgba(255,255,255,0.2)',
          }}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <rect x="3" y="3" width="10" height="10" rx="2" fill="white" fillOpacity="0.9"/>
              <rect x="15" y="3" width="10" height="10" rx="2" fill="white" fillOpacity="0.6"/>
              <rect x="3" y="15" width="10" height="10" rx="2" fill="white" fillOpacity="0.6"/>
              <rect x="15" y="15" width="10" height="10" rx="2" fill="white" fillOpacity="0.9"/>
            </svg>
          </div>
          <div style={{ fontSize: 28, fontWeight: 700, color: 'white', letterSpacing: '-0.5px' }}>
            Proto<span style={{ color: '#90c8f8' }}>Gov</span>
          </div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.65)', marginTop: 4 }}>
            Sistema de Protocolo Municipal
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'white',
          borderRadius: 20,
          padding: '36px 32px',
          boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
        }}>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 4 }}>
            Acessar sistema
          </div>
          <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 28 }}>
            Entre com suas credenciais de acesso
          </div>

          <form onSubmit={entrar}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 6, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                E-mail
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="seu@email.com"
                style={{
                  width: '100%', padding: '12px 14px',
                  border: '1.5px solid #e5e7eb', borderRadius: 10,
                  fontSize: 14, boxSizing: 'border-box',
                  outline: 'none', transition: 'border-color 0.2s',
                  fontFamily: 'inherit',
                }}
                onFocus={e => e.target.style.borderColor = '#185FA5'}
                onBlur={e => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 6, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Senha
              </label>
              <input
                type="password"
                value={senha}
                onChange={e => setSenha(e.target.value)}
                required
                placeholder="••••••••"
                style={{
                  width: '100%', padding: '12px 14px',
                  border: '1.5px solid #e5e7eb', borderRadius: 10,
                  fontSize: 14, boxSizing: 'border-box',
                  outline: 'none', transition: 'border-color 0.2s',
                  fontFamily: 'inherit',
                }}
                onFocus={e => e.target.style.borderColor = '#185FA5'}
                onBlur={e => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>

            {erro && (
              <div style={{
                background: '#fef2f2', border: '1px solid #fecaca',
                borderRadius: 10, padding: '10px 14px',
                fontSize: 13, color: '#dc2626', marginBottom: 16,
                display: 'flex', alignItems: 'center', gap: 8,
              }}>
                <span>⚠️</span> {erro}
              </div>
            )}

            <button
              type="submit"
              disabled={load}
              style={{
                width: '100%', padding: '13px',
                background: load ? '#93c5fd' : 'linear-gradient(135deg, #185FA5, #1e7bc4)',
                color: 'white', border: 'none', borderRadius: 10,
                fontSize: 15, fontWeight: 600, cursor: load ? 'default' : 'pointer',
                boxShadow: load ? 'none' : '0 4px 14px rgba(24,95,165,0.4)',
                transition: 'all 0.2s',
                fontFamily: 'inherit',
              }}
            >
              {load ? 'Entrando...' : 'Entrar →'}
            </button>
          </form>
        </div>

        {/* Link inferior */}
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <a href="/consulta" style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', textDecoration: 'none' }}>
            Consultar processo pelo número →
          </a>
        </div>
      </div>
    </div>
  )
}
